import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export function PurchaseOrderActivityDocumentBadge({
  documentTypeCode,
}: {
  documentTypeCode: string;
}) {
  const { t } = useTranslation('purchaseOrder');

  return (
    <Badge
      className='rounded-full border-zinc-400 bg-white px-3 py-0.5 font-medium text-zinc-700 shadow-none'
      variant='outline'
    >
      {t(`activity.document.badges.${documentTypeCode}`, {
        defaultValue: documentTypeCode,
      })}
    </Badge>
  );
}
